import { css } from '@emotion/css';

import boxShadowMixin from '@editor2/styles/mixins/boxShadow';
import { colors } from '@editor2/styles/colors';
import { lg } from '@editor2/styles/breakpoints';

export const pageCommon = css`
	width: 1000px;
	min-height: 100vh;
	margin: 0 auto;
	margin-right: max((100% - 1000px)/2, 250px);
	display: flex;
	flex-direction: column;
	${boxShadowMixin(2)};

	@media (max-width: ${lg}px) {
		margin-right: auto;
	}

	.form-label {
		font-size: 12px;
		color: #757575;
	}

	.form-control::placeholder {
		color: ${colors.placeholder} !important;
		opacity: 1;
	}

	.CodeMirror pre.CodeMirror-placeholder {
		color: ${colors.placeholder};
	}
`;
